<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="财务流水">
      <template v-if="hasPermission('财务-财务流水-查看')">
        <el-button size="small" type="primary" @click="deliveryWmExtraFee">
          外卖额外支出
        </el-button>

        <el-button size="small" type="primary" @click="deliveryBrushFee"
          >刷单支出</el-button
        >
        <el-button size="small" type="primary" @click="deliveryShippingFee"
          >外卖运费</el-button
        >
        <el-button size="small" type="primary" @click="transferAccounts"
          >转账</el-button
        >
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded(1)"
          >额外收入</el-button
        >
        <el-button
          size="small"
          icon="el-icon-minus"
          type="primary"
          @click="newlyAdded(2)"
          >额外支出</el-button
        >
      </template>
    </pageTitle>

    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">当日流水</div>
                <div class="today summaryLine">
                  <p>
                    {{ (total.today_total_money) | money }}
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">当日收款</div>
                <div class="today summaryLine">
                  <p>{{ total.today_in_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>额外收入{{ total.today_addon_in_money | money }}元</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">当日付款</div>
                <div class="today summaryLine">
                  <p>{{ total.today_out_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>额外支出{{ total.today_addon_out_money | money }}元</p>
              </div>
            </li>
            <!-- <li>
              <div>
                <div class="summaryTitle">昨日流水</div>
                <div class="today summaryLine">
                  <p>
                    {{
                      (total.yestoday_in_money + total.yestoday_out_money)
                        | money
                    }}
                  </p>
                </div>
              </div>
              <div class="subtotals">
                <p>收入：{{ total.yestoday_in_money | money }}</p>
                <p>支出：{{ total.yestoday_out_money | money }}</p>
              </div>
            </li> -->
            <li>
              <div>
                <div class="summaryTitle">流水总金额</div>
                <div class="summaryLine">
                  <p>{{ total.total_money | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">选中合计</div>
                <div class="summaryLine">
                  <p>{{ selectedPayPrice | money }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            resizable
            border
            :height="basicListconfig.height"
            @sortChange="sortChange"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              width="100"
              prop="id"
              label="编号"
              :sortable="true"
            >
              <template #header>
                <el-tooltip effect="dark" content="编号" placement="top-start">
                  <span> 编号</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              width="180"
              prop="create_time"
              label="日期"
              :sortable="true"
            >
              <template #header>
                <el-tooltip effect="dark" content="日期" placement="top-start">
                  <span> 日期</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="客户/供应商"
              width="180"
              show-overflow-tooltip
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="客户/供应商"
                  placement="top-start"
                >
                  <span> 客户/供应商</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              prop="pay_price"
              label="金额"
              :sortable="true"
            >
              <template #header>
                <el-tooltip effect="dark" content="金额" placement="top-start">
                  <span> 金额</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span
                  :class="{
                    'text-green': scope.row.sub_type == 0,
                    'text-red': scope.row.sub_type == 1,
                  }"
                >
                  {{ scope.row.sub_type == 0 ? "+" : "-" }}
                  {{ scope.row.pay_price | money }}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="150" prop="flow_type_name" label="类型">
              <template #header>
                <el-tooltip effect="dark" content="类型" placement="top-start">
                  <span> 类型</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="status_name" label="状态">
              <template #header>
                <el-tooltip effect="dark" content="状态" placement="top-start">
                  <span> 状态</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="账户" align="center">
              <el-table-column width="220" prop="show_name" label="名称">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="名称"
                    placement="top-start"
                  >
                    <span> 名称</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                width="100"
                prop="last_money"
                label="余额"
                :sortable="true"
              >
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="余额"
                    placement="top-start"
                  >
                    <span> 余额</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.last_money | money }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              width="100"
              prop="item_stock_safe"
              label="客户未结"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="客户未结"
                  placement="top-start"
                >
                  <span> 客户未结</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.item_stock_safe | money }}
              </template>
            </el-table-column>

            <el-table-column width="100" prop="user_name" label="操作人">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="操作人"
                  placement="top-start"
                >
                  <span> 操作人</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column width="500" prop="remark" label="备注">
              <template #header>
                <el-tooltip effect="dark" content="备注" placement="top-start">
                  <span> 备注</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="220" prop="show_form_sn" label="单号">
              <template #header>
                <el-tooltip effect="dark" content="单号" placement="top-start">
                  <span> 单号</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <template
                    v-if="
                      hasPermission('财务-财务流水-撤销') &&
                      scope.row.can_withdraw
                    "
                  >
                    <div class="button button_modify" @click="show(scope.row)">
                      <i class="iconfont icon-chehui03"></i> 撤销
                    </div>
                  </template>

                  <template v-if="scope.row.create_time && scope.row.create_time.substr(0, 10) === new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString().substr(0, 10)">
                      <div class="button button_remake_modify" @click="openRemarkDialog(scope.row)">
                          <i class="iconfont icon-bianji" style="color: #409EFF;"></i>  备注
                      </div>
                  </template>

                  <!-- <div class="button button_modify">
                    <i class="iconfont icon-chehui03"></i> 撤销
                  </div> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </basicList>

      <el-dialog
        title="修改备注"
        :visible.sync="remarkDialog.visible"
        width="400px"
        :close-on-click-modal="false"
      >
        <el-form label-position="right" label-width="80px" style="margin-right: 20px;">
          <el-form-item label="类型">
            <el-input :value="remarkDialog.flow_type_name" disabled />
          </el-form-item>
            <el-form-item label="客户名称">
            <el-input :value="remarkDialog.name" disabled />
          </el-form-item>
          <el-form-item label="金额">
            <el-input :value="remarkDialog.pay_price" disabled />
          </el-form-item>
          <el-form-item label="流水日期"  >
            <el-input :value="remarkDialog.create_time" disabled />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="remarkDialog.remark" type="textarea" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="remarkDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="submitRemark">提交</el-button>
        </div>
      </el-dialog>

    <el-dialog
      custom-class="addProductPopUpWindow"
      :title="title"
      :visible.sync="dialogVisible"
      width="550px"
    >
      <el-form
        ref="addform"
        :model="addform"
        :rules="addrules"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="金额" prop="amountOfMoney">
              <el-input
                v-model="addform.amountOfMoney"
                placeholder="请输入金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="type == 1 ? '收入账户' : '支出账户'"
              prop="account_id"
            >
              <el-select
                v-model="addform.account_id"
                size="small"
                placeholder="请选择资金账户"
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属部门" prop="part_id">
              <el-select
                v-model="addform.part_id"
                size="small"
                placeholder="请选择部门"
                style="width: 100%"
              >
                <el-option
                  v-for="item in departmentOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="addform.remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="cancel">取消</el-button>
        <el-button type="danger" @click="reset">重置</el-button>
        <el-button type="success" @click="add">确认新增</el-button>
      </div>
    </el-dialog>

    <formWindow
      v-if="dialogParams.visible"
      :dialogParams="dialogParams"
      @close="handledialogParamsClose"
    >
    </formWindow>

    <!-- 转账弹窗 -->
    <el-dialog
      custom-class="addProductPopUpWindow"
      title="转账"
      :visible.sync="transferVisible"
      width="550px"
    >
      <el-form
        ref="transferForm"
        :model="transferForm"
        :rules="transferRules"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="金额" prop="money">
              <el-input
                v-model="transferForm.money"
                placeholder="请输入金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转出账号" prop="from_payid">
              <el-select
                v-model="transferForm.from_payid"
                style="width: 100%"
                size="small"
                filterable
                clearable
                placeholder="请选择资金账户"
              >
                <el-option
                  v-for="item in accountList_out"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转入账户" prop="to_payid">
              <el-select
                v-model="transferForm.to_payid"
                style="width: 100%"
                size="small"
                filterable
                clearable
                placeholder="请选择资金账户"
              >
                <el-option
                  v-for="item in accountList_in"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="transferForm.remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="transfercancel">取消</el-button>
        <el-button type="danger" @click="transferreset">重置</el-button>
        <el-button type="success" @click="transferadd">确认新增</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="外卖运费"
      :visible.sync="deliveryShippingCostIsVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="addProductPopUpWindow"
    >
      <el-form
        ref="DeliveryShippingFeeForm"
        :rules="deliverrules"
        :model="DeliveryShippingFeeForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="所属门店" prop="shop_id">
              <el-select
                v-model="DeliveryShippingFeeForm.shop_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择所属门店"
              >
                <el-option
                  v-for="item in affiliatedStores"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="外卖平台" prop="customer_id">
              <el-select
                v-model="DeliveryShippingFeeForm.customer_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择转出账户"
              >
                <el-option
                  v-for="item in foodDeliveryPlatform"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="运费金额" prop="money">
              <el-input
                v-model="DeliveryShippingFeeForm.money"
                placeholder="请输入运费金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="付款账号" prop="pay_id">
              <el-select
                v-model="DeliveryShippingFeeForm.pay_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择付款账号"
              >
                <el-option
                  v-for="item in accountList_out"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="DeliveryShippingFeeForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

     <el-dialog
      title="刷单支出"
      :visible.sync="BrushIsVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="addProductPopUpWindow"
    >
      <el-form
        ref="BrushFeeForm"
        :rules="deliverrules"
        :model="BrushFeeForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="所属门店" prop="shop_id">
              <el-select
                v-model="BrushFeeForm.shop_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择所属门店"
              >
                <el-option
                  v-for="item in affiliatedStores"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="外卖平台" prop="customer_id">
              <el-select
                v-model="BrushFeeForm.customer_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择转出账户"
              >
                <el-option
                  v-for="item in foodDeliveryPlatform"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="刷单金额" prop="money">
              <el-input
                v-model="BrushFeeForm.money"
                placeholder="请输入刷单金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="付款账号" prop="pay_id">
              <el-select
                v-model="BrushFeeForm.pay_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择付款账号"
              >
                <el-option
                  v-for="item in accountList_out"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="BrushFeeForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitBursh">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="外卖额外支出"
      :visible.sync="extraFeeVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="addProductPopUpWindow"
    >
      <el-form
        ref="ExtraFeeForm"
        :rules="deliverrules"
        :model="ExtraFeeForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="所属门店" prop="shop_id">
              <el-select
                v-model="ExtraFeeForm.shop_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择所属门店"
              >
                <el-option
                  v-for="item in affiliatedStores"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="外卖平台" prop="customer_id">
              <el-select
                v-model="ExtraFeeForm.customer_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择外卖平台"
              >
                <el-option
                  v-for="item in foodDeliveryPlatform"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="费用类型" prop="price_type">
              <el-select
                v-model="ExtraFeeForm.price_type"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择费用类型"
              >
                <el-option label="保险费" value="1"></el-option>
                <el-option label="推广费" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="费用支出金额" prop="money">
              <el-input
                v-model="ExtraFeeForm.money"
                placeholder="请输入费用支出金额"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="付款账号" prop="pay_id">
              <el-select
                v-model="ExtraFeeForm.pay_id"
                class="formSelect"
                filterable
                clearable
                placeholder="请选择付款账号"
              >
                <el-option
                  v-for="item in accountList_out"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="ExtraFeeForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="extraFeeVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitExtraFee">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getshoplist,
  userPermissionShopGetList,
} from "@/api/basicConfiguration";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import { isMobileNumber, isInteger, validatorPrice } from "@/utils/validate.js";
import {
  billGetList,
  billAdd,
  moveToMoney,
  billFlowTotal,
  checkFlow,
  flowRemarkUp
} from "@/api/bill";
import {
  companyAccountGetList,
  userPermissionCompanyAccountGetList,
} from "@/api/purchasing";
import { partGetlist, userGetlist } from "@/api/basicConfiguration";

// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
  shop_id: "",
};
export default {
  name: "billDetails",
  components: { Treeselect, formWindow: () => import("./formWindow.vue") },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  data() {
    return {
      accountOptions: [],
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [],
      // 弹窗
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        flow_type: null,
      },

      // 汇总数据
      total: {
        total_money: "-",

        yestoday_count: "-",
        yestoday_in_money: "-",
        yestoday_out_money: "-",

        today_count: "-",
        today_in_money: "-",
        today_out_money: "-",
        today_addon_in_money: "-",
        today_addon_out_money: "-",
      },

      // 选中记录
      selectedRows: [],
      selectedPayPrice: 0, // 选中记录和

      // 部门
      departmentOptions: null,

      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 400,
        search: [
          {
            label: "客户/供应商/单号",
            type: "input",
            key: "keywords",
          },
          {
            label: "类型",
            type: "select",
            options: [],
            multiple: true,
            key: "flow_types",
          },
          {
            label: "日期",
            type: "daterange",
            key: "create_time",
          },
          {
            label: "操作人",
            type: "select",
            key: "user_id",
            options: [],
          },
          {
            label: "账户",
            type: "select",
            key: "account",
            options: [],
          },
        ],
        data: [],
        table: true,
        isPage2: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      transferRules: {
        money: [
          {
            validator: validatorPrice,
            message: "请输入正确金额",
            trigger: "blur",
          },
          {
            required: true,
            message: "此项是必填项",
            trigger: "change",
          },
        ],
        from_payid: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
        to_payid: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
      },
      addrules: {
        account_id: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
        part_id: {
          required: true,
          message: "此项是必填项",
          trigger: "blur",
        },
        amountOfMoney: [
          {
            validator: validatorPrice,
            message: "请输入正确金额",
            trigger: "blur",
          },
          {
            required: true,
            message: "此项是必填项",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      addform: {
        amountOfMoney: null,
        account_id: null,
        remark: null,
        part_id: null,
      },
      title: "额外收入",
      type: "",
      accountList: [],
      accountList_in: [],
      accountList_out: [],
      accountList_show: "",
      transferVisible: false,
      transferForm: {
        money: "",
        from_payid: "",
        to_payid: "",
        remark: "",
      },
      deliveryShippingCostIsVisible: false,
      DeliveryShippingFeeForm: {
        shop_id: "",
        customer_id: "",
        money: "",
        pay_id: "",
        remark: "",
      },
      BrushIsVisible: false,
      BrushFeeForm: {
        shop_id: "",
        customer_id: "",
        money: "",
        pay_id: "",
        remark: "",
      },
      affiliatedStores: [],
      foodDeliveryPlatform: [
        {
          label: "美团",
          value: "13",
        },
        {
          label: "饿百",
          value: "12",
        },
      ],
      deliverrules: {
        shop_id: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
        customer_id: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
        money: [
          {
            validator: validatorPrice,
            message: "请输入正确金额",
            trigger: "blur",
          },
          {
            required: true,
            message: "此项是必填项",
            trigger: "blur",
          },
        ],
        pay_id: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
        price_type: {
          required: true,
          message: "请选择费用类型",
          trigger: "change",
        },

      },
      remarkDialog: {
        visible: false,
        id: null,
        create_time: "",
        name: "",
        pay_price: "",
        flow_type_name: "",
        remark: "",
      },
      extraFeeVisible: false, // 控制外卖额外支出弹窗的显示
      ExtraFeeForm: {
        shop_id: "",
        customer_id: "",
        money: "",
        pay_id: "",
        remark: "",
        price_type: "",
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;
    this.obtainDataSource();
    this.getBillFlowTotal();
    this.getPart();
    this.obtainDataSource2().then(() => {
      this.getlist(); // 先拿基础数据，在拉记录
    });
    this.basicListconfig.search.map((item) => {
      if (item.key == "flow_types") {
        item.options = [
          {
            label: "预采单",
            value: 0,
          },
          {
            label: "采购单",
            value: -1,
          },
          {
            label: "销售单",
            value: 1,
          },
          {
            label: "转账出",
            value: -2,
          },
          {
            label: "转账入",
            value: 2,
          },
          {
            label: "合并付款",
            value: -3,
          },
          {
            label: "合并收款",
            value: 3,
          },
          {
            label: "冲帐支出",
            value: -4,
          },
          {
            label: "冲帐收入",
            value: 4,
          },
          {
            label: "额外支出",
            value: -5,
          },
          {
            label: "额外收入",
            value: 5,
          },
          {
            label: "客户余额抵扣",
            value: -8,
          },
          {
            label: "客户余额充值",
            value: 8,
          },
          {
            label: "供应商余额抵扣",
            value: -9,
          },
          {
            label: "供应商余额充值",
            value: 9,
          },
          {
            label: "撤销支出",
            value: -10,
          },
          {
            label: "撤销收入",
            value: 10,
          },
          {
            label: "运费支出",
            value: -11,
          },
          {
            label: "运费收入",
            value: 11,
          },
          {
            label: "外卖运费",
            value: -12,
          },
          {
            label: "刷单收入",
            value: 13,
          },
          {
            label: "刷单支出",
            value: -13,
          },{
            label: "外卖额外支出",
            value: -14,
          }
          
        ];
      }
    });
  },
  methods: {
    // 获取门店列表, 获取供应商列表
    obtainDataSource2() {
      return Promise.all([this.getShops()]);
    },
    // 依据角色与权限拉门店表
    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("采购-采购单-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.affiliatedStores = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
            this.shopIds = res.data.map((item) => item.id);
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.affiliatedStores = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
            this.shopIds = res.data.map((item) => item.id);
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },
    submit() {
      this.$refs["DeliveryShippingFeeForm"].validate((valid) => {
        if (valid) {
          billAdd({
            comp_id: this.compId,
            user_id: this.userId,
            shop_id: this.DeliveryShippingFeeForm.shop_id,
            money: 100 * Number(this.DeliveryShippingFeeForm.money),
            pay_id: this.DeliveryShippingFeeForm.pay_id,
            remark: !!this.DeliveryShippingFeeForm.remark
              ? this.DeliveryShippingFeeForm.remark
              : "",
            part_id: this.addform.part_id,
            flow_type: -12, // 运费支出
            sub_type: 1,

            // 这些字段是写流水要用的，空会报错，所以给个值
            supplier_id: 0,
            customer_id: this.DeliveryShippingFeeForm.customer_id,
            link_sn: "",
          }).then((res) => {
            if (res.code == 1) {
              this.basicListconfig.loading = false;
              this.deliveryShippingCostIsVisible = false;
              this.BrushIsVisible = false;
              
              this.getlist();
            } else if (res.code == 0) {
              this.basicListconfig.loading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    submitBursh() {
      this.$refs["BrushFeeForm"].validate((valid) => {
        if (valid) {
          billAdd({
            comp_id: this.compId,
            user_id: this.userId,
            shop_id: this.BrushFeeForm.shop_id,
            money: 100 * Number(this.BrushFeeForm.money),
            pay_id: this.BrushFeeForm.pay_id,
            remark: !!this.BrushFeeForm.remark
              ? this.BrushFeeForm.remark
              : "",
            part_id: this.addform.part_id,
            flow_type: -13, // 刷单支出
            sub_type: 1,

            // 这些字段是写流水要用的，空会报错，所以给个值
            supplier_id: 0,
            customer_id: this.BrushFeeForm.customer_id,
            link_sn: "",
          }).then((res) => {
            if (res.code == 1) {
              this.basicListconfig.loading = false;
              this.deliveryShippingCostIsVisible = false;
              this.BrushIsVisible = false;
              
              this.getlist();
            } else if (res.code == 0) {
              this.basicListconfig.loading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    deliveryShippingFee() {
      this.deliveryShippingCostIsVisible = true;
      this.DeliveryShippingFeeForm = {
        shop_id: this.shopId,
        customer_id: "",
        money: "",
        pay_id: "",
        remark: "",
      };
      this.$nextTick(() => {
        this.$refs["DeliveryShippingFeeForm"].resetFields();
      });
    },

    deliveryBrushFee(){
      this.BrushIsVisible = true;
      this.BrushFeeForm = {
        shop_id: this.shopId,
        customer_id: "",
        money: "",
        pay_id: "",
        remark: "",
      };
      this.$nextTick(() => {
        this.$refs["BrushFeeForm"].resetFields();
      });
    },

   // 打开外卖额外支出弹窗
   deliveryWmExtraFee() {
      this.extraFeeVisible = true;
      this.ExtraFeeForm = {
        shop_id: this.shopId,
        customer_id: "",
        money: "",
        pay_id: "",
        remark: "",
        price_type: "",
      };
      this.$nextTick(() => {
        this.$refs["ExtraFeeForm"].resetFields();
      });
   },
   // 提交外卖额外支出
   submitExtraFee() {
      this.$refs["ExtraFeeForm"].validate((valid) => {
        if (valid) {
          billAdd({
            comp_id: this.compId,
            user_id: this.userId,
            shop_id: this.ExtraFeeForm.shop_id,
            money: 100 * Number(this.ExtraFeeForm.money),
            pay_id: this.ExtraFeeForm.pay_id,
            remark: !!this.ExtraFeeForm.remark ? this.ExtraFeeForm.remark : "",
            part_id: this.addform.part_id,
            flow_type: -14, // 外卖额外支出
            sub_type: 1,
            price_type: this.ExtraFeeForm.price_type, // 新增费用类型字段
            // 这些字段是写流水要用的，空会报错，所以给个值
            supplier_id: 0,
            customer_id: this.ExtraFeeForm.customer_id,
            link_sn: "",
          }).then((res) => {
            if (res.code == 1) {
              this.basicListconfig.loading = false;
              this.extraFeeVisible = false;
              this.getlist();
            } else if (res.code == 0) {
              this.basicListconfig.loading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },

    handleClose() {
      this.deliveryShippingCostIsVisible = false;
      this.BrushIsVisible = false;
    },
    // 转账按钮
    transferAccounts() {
      this.transferVisible = true;
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    // 查看事件
    show(row) {
      if (
        row.flow_type != 1 &&
        row.flow_type != -1 &&
        row.flow_type != 0 &&
        row.flow_type != -11 &&
        row.flow_type != -12 &&
        row.flow_type != -9 &&
        row.flow_type != -8
      ) {
        this.$message.error("这笔流水不允许撤销");
        return;
      }
      let msg =
        row.flow_type == 1
          ? "销售单"
          : row.flow_type == -1
          ? "采购单"
          : row.flow_type == 0
          ? "预采购单"
          : row.flow_type == -11
          ? "运费支出"
          : row.flow_type == -12
          ? "外卖运费"
          : row.flow_type == -9
          ? "供应商余额抵扣"
          : row.flow_type == -8
          ? "客户余额抵扣"
          : "记录";
      this.$confirm("将对本条" + msg + "执行撤销操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          this.dialogParams.key = new Date().getTime();
          this.dialogParams.data = row;
          this.dialogParams.visible = true;
          this.dialogParams.flow_type = row.flow_type;
          this.dialogParams.id = row.id;
          this.dialogParams.form_sn = row.link_sn;
        })
        .catch((rej) => {});
    },
    handledialogParamsClose() {
      this.dialogParams.id = 0;
      this.dialogParams.key = "";
      this.dialogParams.data = null;
      this.dialogParams.visible = false;
      this.dialogParams.flow_type = 0;
      this.getlist();
    },
    getPart() {
      partGetlist({ comp_id: this.compId, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.departmentOptions = res["data"];
        } else {
          this.$message.error("获取部门信息失败");
        }
      });
    },
    cancel() {
      this.reset();
      this.dialogVisible = false;
    },
    transfercancel() {
      this.transferreset();
      this.transferVisible = false;
    },
    transferreset() {
      this.transferForm = {
        money: "",
        from_payid: "",
        to_payid: "",
        remark: "",
      };
    },
    reset() {
      this.addform = {
        amountOfMoney: null,
        remark: null,
        account_id: null,
        part_id: null,
      };
    },
    transferadd() {
      this.$refs["transferForm"].validate((valid) => {
        if (valid) {
          if (this.transferForm.from_payid === this.transferForm.to_payid) {
            this.$message.error("转账账户和收款账户不能相同");
            return;
          }
          moveToMoney(this.transferForm).then((res) => {
            if (res.code == 1) {
              this.basicListconfig.loading = false;
              this.transfercancel();
              this.getlist();
            } else if (res.code == 0) {
              this.basicListconfig.loading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },

    openRemarkDialog(row) {
      this.remarkDialog = {
        visible: true,
        id: row.id,
        create_time: row.create_time,
        name: row.name,
        pay_price: this.$options.filters.money(row.pay_price),
        flow_type_name: row.flow_type_name,
        remark: row.remark || "",
      };
    },
    // 修改备注
    submitRemark() {
      flowRemarkUp({
        comp_id: this.compId,
        id: this.remarkDialog.id,
        remark: this.remarkDialog.remark
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success("备注修改成功");
          this.remarkDialog.visible = false;
          this.getlist();
        } else {
          this.$message.error(res.msg || "备注修改失败");
        }
      });
    },

    add() {
      this.$refs["addform"].validate((valid) => {
        if (valid) {
          billAdd({
            comp_id: this.compId,
            user_id: this.userId,
            shop_id: this.shopId,
            money: 100 * Number(this.addform.amountOfMoney),
            pay_id: this.addform.account_id,
            remark: !!this.addform.remark ? this.addform.remark : "",
            part_id: this.addform.part_id,
            flow_type: this.type == 1 ? 5 : -5, // 额外收入，额外支出
            sub_type: this.type == 1 ? 0 : 1,

            // 这些字段是写流水要用的，空会报错，所以给个值
            supplier_id: 0,
            customer_id: 0,
            link_sn: "",
          }).then((res) => {
            if (res.code == 1) {
              this.basicListconfig.loading = false;
              this.reset();
              this.dialogVisible = false;
              this.getlist();
            } else if (res.code == 0) {
              this.basicListconfig.loading = false;
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    newlyAdded(num) {
      this.type = num;
      this.title = num == 1 ? "额外收入" : "额外支出";
      this.accountList = num == 1 ? this.accountList_in : this.accountList_out;
      this.addform.part_id = this.$store.getters.userInfo.part_id;
      this.dialogVisible = true;
    },
    // 表格选择数据事件
    handleSelectionChange(val) {
      this.selectedRows = val;
      this.selectedPayPrice = this.selectedRows.reduce(
        (accumulator, currentValue) => {
          if (currentValue.sub_type == 0) {
            return accumulator + currentValue.pay_price;
          } else {
            return accumulator - currentValue.pay_price; // 确保是减去 pay_price
          }
        },
        0
      );
    },
    // 新增事件
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        delete data.shop_id;
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0 && key == "create_time") {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
              delete this.basicListconfig.searchParameters["flow_type"];
            } else {
              if (key == "flow_types") {
                this.basicListconfig.searchParameters["flow_type"] =
                  data[key].join(",");
              } else {
                this.basicListconfig.searchParameters.begin_time = data[key][0];
                this.basicListconfig.searchParameters.end_time = data[key][1];
              }
            }
          }
          if (data[key]) {
            this.basicListconfig.searchParameters[key] = data[key];
          } else {
            delete this.basicListconfig.searchParameters[key];
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
      this.getBillFlowTotal();
    },
    // 获取列表内容
    getlist() {
      checkFlow().then((res) => {
        if (res.errorCount > 0) {
          // this.$message.error();
          this.$alert(res.data, "提示", {
            dangerouslyUseHTMLString: true,
          });
        }
      });
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      // 店员只能看指定查看权限的资金账户
      if (this.roleId == 4) {
        this.basicListconfig.searchParameters["account_id"] = this
          .basicListconfig.searchParameters.account
          ? this.basicListconfig.searchParameters.account
          : this.accountList_show;
      }
      this.basicListconfig.searchParameters.shop_id = this.shopIds.join(", ");
      billGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            item.name =
              item.customer_name && item.customer_name != "-"
                ? item.customer_name
                : item.supplier_name;
            item.show_name = item.account_name;
            if (item.from_source == "account") {
              item.show_name = "" + item.account_name;
            }
            if (item.from_source == "supplier") {
              item.show_name = item.supplier_name + " 供应商余额账户";
            }
            if (item.from_source == "customer") {
              item.show_name = item.customer_name + " 客户余额账户";
            }

            item.show_form_sn = item.link_sn ? item.link_sn : item.form_sn;

            item.status = Number(item.status);
            item.can_withdraw = false;
            if (
              item.status == 0 &&
              (item.flow_type == -1 ||
                item.flow_type == 1 ||
                item.flow_type == -11 ||
                item.flow_type == -12 ||
                item.flow_type == -9 ||
                item.flow_type == -8)
            ) {
              item.can_withdraw = true;
            }
            item.status_name = item.status == 0 ? "正常" : "撤销";
            return item;
          });
          this.basicListconfig.total = res.count;
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    getBillFlowTotal() {
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      billFlowTotal(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.total = { ...res.data };
        } else if (res.code == 0) {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      // 获取用户列表
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.msg || "获取用户数据源失败！");
        }
      });
      
      // 取公司资金账户：有权限控制
      if (this.roleId == 4) {
        // 付款
        userPermissionCompanyAccountGetList({
          comp_id: this.compId,
          user_id: this.userId,
          op_type: 2, // 0 查看 1 收款 2 付款
        }).then((res) => {
          if (res.code == 1) {
            this.accountList_out = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.account_id,
                money: this.$money(item.money),
              };
            });
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });

        // 收款
        userPermissionCompanyAccountGetList({
          comp_id: this.compId,
          user_id: this.userId,
          op_type: 1, // 0 查看 1 收款 2 付款
        }).then((res) => {
          if (res.code == 1) {
            this.accountList_in = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.account_id,
                money: this.$money(item.money),
              };
            });
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });

        // 查看
        userPermissionCompanyAccountGetList({
          comp_id: this.compId,
          user_id: this.userId,
          op_type: 0, // 0 查看 1 收款 2 付款
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "account") {
                item.options = res.data.map((n) => {
                  return {
                    label: n.account_name,
                    value: n.id,
                  };
                });
              }
            });
            this.accountList_show = res.data
              .map((item) => item.account_id)
              .join(",");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });

        // 取公司资金账户：不受权限控制
      } else {
        companyAccountGetList({
          comp_id: this.compId,
          limit: 10000,
          status: 0,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "account") {
                item.options = res.data.map((n) => {
                  return {
                    label: n.account_name,
                    value: n.id,
                  };
                });
              }
            });
            this.accountList_in = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.id,
                money: this.$money(item.money),
              };
            });
            this.accountList_out = this.accountList_in;
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });
      }
    },
  },
};
</script>

<style>
.text-green {
  color: green;
}

.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/billDetails/index.vue